export default __webpack_public_path__ + "static/bkm-ee7b7a99e9f14a1abfd011d44d662ef3.svg";